export const microData = [
    {
        name: 'Fabio Viviani',
        portrait: 'https://msobd-storage.azureedge.net/images/microInfluencers/fabio_viviani/portrait.jpg',
        profile: {
            title: 'Original by Fabio Viviani',
            signature: 'https://msobd-storage.azureedge.net/images/microInfluencers/fabio_viviani/signature.png',
            description: 'Fabio Viviani has spent a lifetime enriching our world and inspiring people through new, original experiences in dining. He says that originality comes from the core of who we were born to be: “The most important thing is to stand firm on your principles, passions, and awareness for who you are.”',
            backgrounds: {
                400: 'https://msobd-storage.azureedge.net/images/microInfluencers/fabio_viviani/Fabio_bg_SV.jpg',
                1024: 'https://msobd-storage.azureedge.net/images/microInfluencers/fabio_viviani/Fabio_bg_S.jpg',
                1350: 'https://msobd-storage.azureedge.net/images/microInfluencers/fabio_viviani/Fabio_bg_M.jpg',
                default: 'https://msobd-storage.azureedge.net/images/microInfluencers/fabio_viviani/Fabio_bg_L.jpg'
            },
            gallery: [
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/fabio_viviani/Fabio-01-M.jpg'
                    },
                    alt: ''
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/fabio_viviani/Fabio-02-M.jpg'
                    },
                    alt: ''
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/fabio_viviani/Fabio-03-M.jpg'
                    },
                    alt: ''
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/fabio_viviani/Fabio-04-M.jpg'
                    },
                    alt: ''
                },
                {
                    images: {
                        400: 'https://msobd-storage.azureedge.net/images/microInfluencers/fabio_viviani/Fabio-05-M.jpg',
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/fabio_viviani/Fabio-05-L.jpg'
                    },
                    alt: ''
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/fabio_viviani/Fabio-06-M.jpg'
                    },
                    alt: ''
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/fabio_viviani/Fabio-07-M.jpg'
                    },
                    alt: ''
                }
            ]
        }
    },
    {
        name: 'Marcus Rivero',
        portrait: 'https://msobd-storage.azureedge.net/images/microInfluencers/marcus_rivero/portrait.jpg',
        profile: {
            title: 'Original by Marcus Rivero',
            signature: 'https://msobd-storage.azureedge.net/images/microInfluencers/marcus_rivero/signature.png',
            description: 'Marcus Rivero, AKA Soles By Sir, has spent over a decade handcrafting his originality by creating custom shoes for athletes across all sports. All of his original creations are 1-of-1, and he takes pride in trying to outdo himself with every new pair. To Marcus, originality is about making your own path and finding inspiration from anything and everything you&nbsp;see.',
            backgrounds: {
                400: 'https://msobd-storage.azureedge.net/images/microInfluencers/marcus_rivero/Marcus_bg_SV.jpg',
                1024: 'https://msobd-storage.azureedge.net/images/microInfluencers/marcus_rivero/Marcus_bg_S.jpg',
                1350: 'https://msobd-storage.azureedge.net/images/microInfluencers/marcus_rivero/Marcus_bg_M.jpg',
                default: 'https://msobd-storage.azureedge.net/images/microInfluencers/marcus_rivero/Marcus_bg_L.jpg'
            },
            gallery: [
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/marcus_rivero/Marcus-01-M.jpg'
                    },
                    alt: 'Original, custom-made kicks',
                    size: 'square'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/marcus_rivero/Marcus-02-M.jpg'
                    },
                    alt: 'Original, custom-made kicks',
                    size: 'wide'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/marcus_rivero/Marcus-03-M.jpg'
                    },
                    alt: 'Original, custom-made kicks',
                    size: 'square'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/marcus_rivero/Marcus-04-M.jpg'
                    },
                    alt: 'Marcus Rivero creating an original pair of sneakers',
                    size: 'square'
                },
                {
                    images: {
                        400: 'https://msobd-storage.azureedge.net/images/microInfluencers/marcus_rivero/Marcus-05-M.jpg',
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/marcus_rivero/Marcus-05-L.jpg'
                    },
                    alt: 'Marcus Rivero creating an original pair of sneakers',
                    size: 'square'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/marcus_rivero/Marcus-06-M.jpg'
                    },
                    alt: 'Marcus Rivero creating an original pair of sneakers',
                    size: 'square'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/marcus_rivero/Marcus-07-M.jpg'
                    },
                    alt: 'Marcus Rivero creating an original pair of sneakers',
                    size: 'square'
                },

                // {
                //     video: './videos/video2.mp4',
                //     videoTitle: "Shoe Talkin' w/ Marcus Rivero - Ep. 1",
                //     poster: 'images/microInfluencers/marcus_rivero/gallery4.jpg'
                // },
            ]
        }
    },
    {
        name: 'Collete Davis',
        portrait: 'https://msobd-storage.azureedge.net/images/microInfluencers/collete_davis/portrait.jpg',
        profile: {
            title: 'Original by Collete Davis',
            signature: 'https://msobd-storage.azureedge.net/images/microInfluencers/collete_davis/signature.png',
            description: 'Collete Davis is a racing driver, car builder, content creator and TV host creating new lanes in the world of motorsports. Whether it’s going head-to-head on the racetrack, or crafting dream cars in her garage, she’s taken a driver’s seat in shifting the perception of women in the automotive industry, challenging the norms and the odds to fuel her original true self—and inspiring others to do&nbsp;the&nbsp;same.',
            backgrounds: {
                400: 'https://msobd-storage.azureedge.net/images/microInfluencers/collete_davis/Collete-bg_SV.jpg',
                1024: 'https://msobd-storage.azureedge.net/images/microInfluencers/collete_davis/Collete-bg_S.jpg',
                1350: 'https://msobd-storage.azureedge.net/images/microInfluencers/collete_davis/Collete-bg_M.jpg',
                default: 'https://msobd-storage.azureedge.net/images/microInfluencers/collete_davis/Collete-bg_L.jpg'
            },
            gallery: [
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/collete_davis/Collete-01-M.jpg'
                    },
                    alt: ''
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/collete_davis/Collete-02-M.jpg'
                    },
                    alt: ''
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/collete_davis/Collete-03-M.jpg'
                    },
                    alt: ''
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/collete_davis/Collete-04-M.jpg'
                    },
                    alt: ''
                },
                {
                    images: {
                        400: 'https://msobd-storage.azureedge.net/images/microInfluencers/collete_davis/Collete-05-M.jpg',
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/collete_davis/Collete-05-L.jpg'
                    },
                    alt: ''
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/collete_davis/Collete-06-M.jpg'
                    },
                    alt: ''
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/collete_davis/Collete-07-M.jpg'
                    },
                    alt: ''
                }
            ]
        }
    },
    {
        name: 'DJ HAPA',
        portrait: 'https://msobd-storage.azureedge.net/images/microInfluencers/dj_hapa/portrait.jpg',
        profile: {
            title: 'Original by DJ HAPA',
            signature: 'https://msobd-storage.azureedge.net/images/microInfluencers/dj_hapa/signature.png',
            description: 'As a performer, DJ HAPA has redefined what it means to DJ by creating his original mixes using a Surface Studio 2 and Surface Dial. As a college professor, he has inspired students and educators alike by building immersive, educational lessons using virtual reality. His signature “feel-good” sound has led him to share the stage with globally-renowned artists, proving once again that originality knows&nbsp;no&nbsp;genre. ',
            backgrounds: {
                400: 'https://msobd-storage.azureedge.net/images/microInfluencers/dj_hapa/Hapa_bg_SV.jpg',
                1024: 'https://msobd-storage.azureedge.net/images/microInfluencers/dj_hapa/Hapa_bg_S.jpg',
                1350: 'https://msobd-storage.azureedge.net/images/microInfluencers/dj_hapa/Hapa_bg_M.jpg',
                default: 'https://msobd-storage.azureedge.net/images/microInfluencers/dj_hapa/Hapa_bg_L.jpg'
            },
            gallery: [
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/dj_hapa/Hapa-01-M.jpg'
                    },
                    alt: '',
                    size: 'tall'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/dj_hapa/Hapa-02-M.jpg'
                    },
                    alt: '',
                    size: 'square'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/dj_hapa/Hapa-03-M.jpg'
                    },
                    alt: '',
                    size: 'wide'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/dj_hapa/Hapa-04-M.jpg'
                    },
                    alt: '',
                    size: 'tall'
                },
                {
                    images: {
                        400: 'https://msobd-storage.azureedge.net/images/microInfluencers/dj_hapa/Hapa-05-M.jpg',
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/dj_hapa/Hapa-05-L.jpg'
                    },
                    alt: '',
                    size: 'square'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/dj_hapa/Hapa-06-M.jpg'
                    },
                    alt: '',
                    size: 'wide'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/dj_hapa/Hapa-07-M.jpg'
                    },
                    alt: '',
                    size: 'wide'
                }
            ]
        }
    },
    {
        name: 'Avi Schiffmann',
        portrait: 'https://msobd-storage.azureedge.net/images/microInfluencers/avi_schiffman/portrait.jpg',
        profile: {
            title: 'Original by Avi Schiffmann',
            signature: 'https://msobd-storage.azureedge.net/images/microInfluencers/avi_schiffman/signature.png',
            description: 'Avi Schiffmann used his programming skills to make an impact when he developed one of the first and best coronavirus tracking sites. He’s since continued to do good on a massive scale through technology by making sites for Black Lives Matter and the 2020 election—all before attending college. His drive stems from a belief that we all have the potential to find original solutions, push what’s possible, and write a better future; it just starts with believing&nbsp;we&nbsp;can.',
            backgrounds: {
                400: 'https://msobd-storage.azureedge.net/images/microInfluencers/avi_schiffman/Avi-BG_SV.jpg',
                1024: 'https://msobd-storage.azureedge.net/images/microInfluencers/avi_schiffman/Avi-BG_S.jpg',
                1350: 'https://msobd-storage.azureedge.net/images/microInfluencers/avi_schiffman/Avi-BG_M.jpg',
                default: 'https://msobd-storage.azureedge.net/images/microInfluencers/avi_schiffman/Avi-BG_L.jpg'
            },
            gallery: [
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/avi_schiffman/Avi-01-M.jpg'
                    },
                    alt: '',
                    size: 'wide'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/avi_schiffman/Avi-02-M.jpg'
                    },
                    alt: '',
                    size: 'tall'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/avi_schiffman/Avi-03-M.jpg'
                    },
                    alt: '',
                    size: 'tall'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/avi_schiffman/Avi-04-M.jpg'
                    },
                    alt: '',
                    size: 'square'
                },
                {
                    images: {
                        400: 'https://msobd-storage.azureedge.net/images/microInfluencers/avi_schiffman/Avi-05-M.jpg',
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/avi_schiffman/Avi-05-L.jpg'
                    },
                    alt: '',
                    size: 'square'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/avi_schiffman/Avi-06-M.jpg'
                    },
                    alt: '',
                    size: 'square'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/avi_schiffman/Avi-07-M.jpg'
                    },
                    alt: '',
                    size: 'square'
                }
            ]
        }
    },

    // {
    //     name: 'Surfaces',
    //     portrait: 'https://msobd-storage.azureedge.net/images/microInfluencers/surface/portrait.jpg',
    //     profile: {
    //         title: 'Original by Surfaces',
    //         signature: 'https://msobd-storage.azureedge.net/images/microInfluencers/surface/signature.png',
    //         description: 'Music duo Surfaces knows the power music holds in bringing people together. That’s why their sound is rooted in a blissful, positive warmth—to inspire the ideas of unity and community in anyone who’s listening, no matter who they are or where they’re from. After all, it’s when we embrace the best in others that we truly embrace our own original selves, and Surfaces has found a way to show the world this connection in&nbsp;perfect&nbsp;harmony.',
    //         backgrounds: {
    //             400: 'https://msobd-storage.azureedge.net/images/microInfluencers/surface/Surface_bg_SV.jpg',
    //             1024: 'https://msobd-storage.azureedge.net/images/microInfluencers/surface/Surface_bg_S.jpg',
    //             1350: 'https://msobd-storage.azureedge.net/images/microInfluencers/surface/Surface_bg_M.jpg',
    //             default: 'https://msobd-storage.azureedge.net/images/microInfluencers/surface/Surface_bg_L.jpg'
    //         },
    //         gallery: [
    //             {
    //                 images: {
    //                     default: 'https://msobd-storage.azureedge.net/images/microInfluencers/surface/Surface-01-M.jpg'
    //                 },
    //                 alt: '',
    //                 size: 'wide'
    //             },
    //             {
    //                 images: {
    //                     default: 'https://msobd-storage.azureedge.net/images/microInfluencers/surface/Surface-02-M.jpg'
    //                 },
    //                 alt: '',
    //                 size: 'tall'
    //             },
    //             {
    //                 images: {
    //                     default: 'https://msobd-storage.azureedge.net/images/microInfluencers/surface/Surface-03-M.jpg'
    //                 },
    //                 alt: '',
    //                 size: 'tall'
    //             },
    //             {
    //                 images: {
    //                     default: 'https://msobd-storage.azureedge.net/images/microInfluencers/surface/Surface-04-M.jpg'
    //                 },
    //                 alt: '',
    //                 size: 'square'
    //             },
    //             {
    //                 images: {
    //                     400: 'https://msobd-storage.azureedge.net/images/microInfluencers/surface/Surface-05-M.jpg',
    //                     default: 'https://msobd-storage.azureedge.net/images/microInfluencers/surface/Surface-05-L.jpg'
    //                 },
    //                 alt: '',
    //                 size: 'square'
    //             },
    //             {
    //                 images: {
    //                     default: 'https://msobd-storage.azureedge.net/images/microInfluencers/surface/Surface-06-M.jpg'
    //                 },
    //                 alt: '',
    //                 size: 'square'
    //             },
    //             {
    //                 images: {
    //                     default: 'https://msobd-storage.azureedge.net/images/microInfluencers/surface/Surface-07-M.jpg'
    //                 },
    //                 alt: '',
    //                 size: 'square'
    //             }
    //         ]
    //     }
    // },

    // {
    //     name: 'Lewis Howes',
    //     portrait: 'https://msobd-storage.azureedge.net/images/microInfluencers/lewis/portrait.jpg',
    //     profile: {
    //         title: 'Original by Lewis Howes',
    //         signature: 'https://msobd-storage.azureedge.net/images/microInfluencers/lewis/signature.png',
    //         description: 'Lewis Howes is many things: an athlete, entrepreneur, author, and thought leader who’s used his success across those disciplines to inspire the same success in others. From his time spent on the professional football field to the New York Times Best-Seller List, top podcast charts, Forbes, and more, he’s proof that our originality doesn’t have to be defined by any one single talent or skill, but by whatever ambition we decide to put our heads to—hone it, craft it, share it with the world, and results&nbsp;will&nbsp;follow.',
    //         backgrounds: {
    //             400: 'https://msobd-storage.azureedge.net/images/microInfluencers/lewis/Lewis_bg_SV.jpg',
    //             1024: 'https://msobd-storage.azureedge.net/images/microInfluencers/lewis/Lewis_bg_S.jpg',
    //             1350: 'https://msobd-storage.azureedge.net/images/microInfluencers/lewis/Lewis_bg_M.jpg',
    //             default: 'https://msobd-storage.azureedge.net/images/microInfluencers/lewis/Lewis_bg_L.jpg'
    //         },
    //         gallery: [
    //             {
    //                 images: {
    //                     default: 'https://msobd-storage.azureedge.net/images/microInfluencers/lewis/Lewis-01-M.jpg'
    //                 },
    //                 alt: '',
    //                 size: 'wide'
    //             },
    //             {
    //                 images: {
    //                     default: 'https://msobd-storage.azureedge.net/images/microInfluencers/lewis/Lewis-02-M.jpg'
    //                 },
    //                 alt: '',
    //                 size: 'tall'
    //             },
    //             {
    //                 images: {
    //                     default: 'https://msobd-storage.azureedge.net/images/microInfluencers/lewis/Lewis-03-M.jpg'
    //                 },
    //                 alt: '',
    //                 size: 'tall'
    //             },
    //             {
    //                 images: {
    //                     default: 'https://msobd-storage.azureedge.net/images/microInfluencers/lewis/Lewis-04-M.jpg'
    //                 },
    //                 alt: '',
    //                 size: 'square'
    //             },
    //             {
    //                 images: {
    //                     400: 'https://msobd-storage.azureedge.net/images/microInfluencers/lewis/Lewis-05-M.jpg',
    //                     default: 'https://msobd-storage.azureedge.net/images/microInfluencers/lewis/Lewis-05-L.jpg'
    //                 },
    //                 alt: '',
    //                 size: 'square'
    //             },
    //             {
    //                 images: {
    //                     default: 'https://msobd-storage.azureedge.net/images/microInfluencers/lewis/Lewis-06-M.jpg'
    //                 },
    //                 alt: '',
    //                 size: 'square'
    //             },
    //             {
    //                 images: {
    //                     default: 'https://msobd-storage.azureedge.net/images/microInfluencers/lewis/Lewis-07-M.jpg'
    //                 },
    //                 alt: '',
    //                 size: 'square'
    //             }
    //         ]
    //     }
    // },
    {
        name: 'Reyna Noriega',
        portrait: 'https://msobd-storage.azureedge.net/images/microInfluencers/reyna/portrait.jpg',
        profile: {
            title: 'Original by Reyna Noriega',
            signature: 'https://msobd-storage.azureedge.net/images/microInfluencers/reyna/signature.png',
            description: 'Reyna Noriega is a Miami-based Black and Afro-Latina visual artist, author, and educator dedicated to uplifting and highlighting women through her work. An artist across mediums, from graphic design to painting, digital illustration, and photography, Reyna uses her bold, uniquely original style to create art that offers a window into her life and the lives of all women. She’s used this to inspire the creation of forward-thinking business and brands that stand for equity and inclusion, so that women everywhere can feel recognized and empowered in finding success—both in their personal lives and their&nbsp;professional&nbsp;ambitions.',
            backgrounds: {
                400: 'https://msobd-storage.azureedge.net/images/microInfluencers/reyna/Reyna_bg_SV.jpg',
                1024: 'https://msobd-storage.azureedge.net/images/microInfluencers/reyna/Reyna_bg_S.jpg',
                1350: 'https://msobd-storage.azureedge.net/images/microInfluencers/reyna/Reyna_bg_M.jpg',
                default: 'https://msobd-storage.azureedge.net/images/microInfluencers/reyna/Reyna_bg_L.jpg'
            },
            gallery: [
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/reyna/Reyna-01-M.jpg'
                    },
                    alt: '',
                    size: 'wide'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/reyna/Reyna-02-M.jpg'
                    },
                    alt: '',
                    size: 'tall'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/reyna/Reyna-03-M.jpg'
                    },
                    alt: '',
                    size: 'tall'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/reyna/Reyna-04-M.jpg'
                    },
                    alt: '',
                    size: 'square'
                },
                {
                    images: {
                        400: 'https://msobd-storage.azureedge.net/images/microInfluencers/reyna/Reyna-05-M.jpg',
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/reyna/Reyna-05-L.jpg'
                    },
                    alt: '',
                    size: 'square'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/reyna/Reyna-06-M.jpg'
                    },
                    alt: '',
                    size: 'square'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/reyna/Reyna-07-M.jpg'
                    },
                    alt: '',
                    size: 'square'
                }
            ]
        }
    },
    {
        name: 'Chase Jarvis',
        portrait: 'https://msobd-storage.azureedge.net/images/microInfluencers/chase/portrait.jpg',
        profile: {
            title: 'Original by Chase Jarvis',
            signature: 'https://msobd-storage.azureedge.net/images/microInfluencers/chase/signature.png',
            description: 'Chase Jarvis is an award-winning artist, entrepreneur, and one of the most influential photographers of the past 20 years. From creating advertising campaigns for major global brands, to working with celebrated athletes and pop culture icons, to finding CreativeLive as a resource for students to learn photography, video, design, and more, Chase has dedicated his life to using his originality—through his skills, ideas, and experiences—to inspire others in following their artistic passions and turning their dreams&nbsp;into&nbsp;reality.',
            backgrounds: {
                400: 'https://msobd-storage.azureedge.net/images/microInfluencers/chase/Chase_bg_SV.jpg',
                1024: 'https://msobd-storage.azureedge.net/images/microInfluencers/chase/Chase_bg_S.jpg',
                1350: 'https://msobd-storage.azureedge.net/images/microInfluencers/chase/Chase_bg_M.jpg',
                default: 'https://msobd-storage.azureedge.net/images/microInfluencers/chase/Chase_bg_L.jpg'
            },
            gallery: [
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/chase/Chase-01-M.jpg'
                    },
                    alt: '',
                    size: 'wide'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/chase/Chase-02-M.jpg'
                    },
                    alt: '',
                    size: 'tall'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/chase/Chase-03-M.jpg'
                    },
                    alt: '',
                    size: 'tall'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/chase/Chase-04-M.jpg'
                    },
                    alt: '',
                    size: 'square'
                },
                {
                    images: {
                        400: 'https://msobd-storage.azureedge.net/images/microInfluencers/chase/Chase-05-M.jpg',
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/chase/Chase-05-L.jpg'
                    },
                    alt: '',
                    size: 'square'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/chase/Chase-06-M.jpg'
                    },
                    alt: '',
                    size: 'square'
                },
                {
                    images: {
                        default: 'https://msobd-storage.azureedge.net/images/microInfluencers/chase/Chase-07-M.jpg'
                    },
                    alt: '',
                    size: 'square'
                }
            ]
        }
    }


]